var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontnosmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218,202.2c3,1.4,6,1.8,9,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.5,193.2c-19,0-38,0-57,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.5,230.2c-0.8,1.8-0.5,3.7-0.5,5.5c0,11.8,0,23.7,0,35.5c-0.1,12.7-4.8,23.7-12.6,33.4 c-4.1,5.1-8.9,9.7-13.4,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.5,230.2c1.1,5,0.4,10,0.5,15c0.1,7.8-0.1,15.7,0.1,23.5c0.3,15.2,5.6,28.4,16,39.5c3.4,3.6,7.2,6.8,10,11 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134,57.7c0,21.8,0,43.7,0,65.5c-0.1,35.3,10.1,67,33.5,94c10.4,12,22.6,21.4,37.5,26.9 c12,4.4,24.1,3.1,35.4-2.1c14-6.3,26-15.8,36-27.5c10.6-12.4,19.5-25.9,25.1-41.4c4.7-13.1,7.7-26.4,7.6-40.5 c-0.3-24.7-0.1-49.3-0.1-74"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontnosmile);
export default __webpack_public_path__ + "static/media/frontnosmile.46fdf5b436c292b9a56b0ebfbaa0c559.svg";
export { ForwardRef as ReactComponent };